export default __webpack_public_path__ + "static/media/segre05.563ad6ad.jpg";